import React from 'react';
import { OptionProps, SelectSize } from './types';

const getOptionClasses = (size: SelectSize, disabled: boolean | undefined) => {
  const sizeClasses = {
    sm: 'py-1.5 px-3 text-xs',
    md: 'py-1.5 px-3 text-sm',
    lg: 'py-2 px-3.5 text-sm',
  };

  return [
    'flex items-center gap-2',
    'cursor-pointer text-neutral-900 transition-colors duration-200',
    'hover:bg-neutral-100/50 active:bg-neutral-100',
    disabled ? 'opacity-50 cursor-not-allowed' : '',
    sizeClasses[size],
  ].join(' ');
};

const getDecoratorClasses = (
  size: SelectSize,
  disabled: boolean | undefined
) => {
  const sizeClasses = {
    sm: 'text-base',
    md: 'text-base',
    lg: 'text-lg',
  };

  return `flex items-center ${sizeClasses[size]} ${
    disabled ? 'text-neutral-300' : 'text-neutral-500'
  }`;
};

const Option: React.FC<OptionProps> = ({
  value,
  children,
  disabled = false,
  className = '',
  startDecorator,
  endDecorator,
  onClick,
  size = 'md',
}): React.ReactElement => {
  const handleClick = (event: React.MouseEvent) => {
    if (!disabled && onClick) {
      onClick(event);
    }
  };

  return (
    <li
      role="option"
      aria-selected={false}
      data-value={value}
      onClick={handleClick}
      className={`
        ${getOptionClasses(size, disabled)}
        ${className}
      `}
      data-disabled={disabled}
    >
      {startDecorator && (
        <span className={getDecoratorClasses(size, disabled)}>
          {startDecorator}
        </span>
      )}
      <span className="flex-grow min-w-0">{children}</span>
      {endDecorator && (
        <span className={getDecoratorClasses(size, disabled)}>
          {endDecorator}
        </span>
      )}
    </li>
  );
};

export default Option;
